module.exports = __webpack_public_path__ + "static/media/dclogo.7120994f.gif";